<template>
  <b-loading :is-full-page="true" :active.sync="isLoading" :can-cancel="false"></b-loading>
</template>

<script>
export default {
  name: 'fullpageLoader',
  computed: {
    isLoading () {
      return this.$store.getters.isFullPageLoading
    }
  }
}
</script>

<style>

</style>
